import React, { useMemo, memo, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTable, useRowSelect } from "react-table";
import numeral from "numeral";
import classNames from "classnames";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { Dialog } from "@headlessui/react";

// COMPONENTS
import LoadingMutation from "../Loading/LoadingMutation";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";
import { useState } from "react";

// EVENT
import { EmitterStatus } from "../../event";

const Row = memo(({ row, i, value, getData }) => {
  const [showModal, setShowModal] = useState(false);

  const alignByIndex = (index) => {
    if (index == 0) return "text-left";
    // if (index == 1) return "text-right";
    return "text-center";
  };

  return (
    <React.Fragment>
      <tr
        onClick={() => setShowModal(true)}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 " + alignByIndex(index)}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      <ChatBotDialog
        isCreated={false}
        row={row}
        showModal={showModal}
        setShowModal={setShowModal}
        getData={getData}
      />
    </React.Fragment>
  );
});

export const ChatBotDialog = ({
  showModal,
  setShowModal,
  row,
  getData,
  isCreated = false,
}) => {
  const { keyword, order, answer } = row.original;

  const [error, setError] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);

  const [form, setForm] = useState({
    newKeyword: "",
    keyword,
    answer,
  });

  const onSubmit = async () => {
    try {
      if (!form.answer || (!form.keyword?.length && !form.newKeyword)) {
        return setError(true);
      }

      setLoadingAdd(true);
      if (isCreated) {
        await API.post("MoneyHubAdmin", `/chatbot`, {
          body: {
            keyword: form.keyword,
            answer: form.answer,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        setForm({ newKeyword: "", keyword: [], answer: "" });
      } else {
        await API.put("MoneyHubAdmin", `/chatbot/${order}`, {
          body: {
            keyword: form.keyword,
            answer: form.answer,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
      await getData({}, { isLoading: false });
      setLoadingAdd(false);
      await EmitterStatus("SUCCESS");
    } catch (error) {
      console.log("ERRO", error);
      await EmitterStatus("ERROR", { logMessage: error });
    }
  };

  const onField = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const addKeyword = () => {
    setForm((prev) => {
      return {
        ...prev,
        newKeyword: "",
        keyword: [...prev.keyword, form.newKeyword],
      };
    });
  };

  const deleteKeyword = (index) => () => {
    setForm((prev) => {
      const newKeyword = prev.keyword?.filter((_, i) => i !== index);
      return {
        ...prev,
        keyword: newKeyword,
      };
    });
  };

  return (
    <Dialog
      open={showModal}
      className="fixed z-10 inset-0 overflow-y-auto"
      onClose={() => setShowModal(false)}
    >
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-white border border-gray-300 rounded w-96 max-w-sm mx-auto p-4 z-20">
          <Dialog.Title className="font-black text-lg">
            เพิ่ม / แก้ไข
          </Dialog.Title>
          <Dialog.Description className="my-4">
            <div>
              <div className="w-32">คำตอบ</div>
              <textarea
                className="border border-gray-300 focus:outline-none px-3 py-2 rounded w-full"
                rows={4}
                type="text"
                name="answer"
                value={form.answer}
                onChange={onField}
              />
              <span className="text-red-400 mx-2">
                {error && !form.answer && "โปรดใส่คำตอบ"}
              </span>
            </div>
            <div>
              <div className="w-32">คีย์เวิร์ด</div>
              <div className="flex items-center">
                <input
                  className="border border-gray-300 focus:outline-none px-3 py-2 rounded w-full"
                  rows={4}
                  type="text"
                  name="newKeyword"
                  value={form.newKeyword}
                  onChange={onField}
                />
                <div>
                  {" "}
                  <button
                    onClick={addKeyword}
                    className={classNames(
                      "mx-2 px-3 py-3 h-full text-sm rounded text-white shadow-sm duration-300 transition-all focus:outline-none bg-blue-500 hover:bg-blue-600"
                    )}
                  >
                    เพิ่ม
                  </button>
                </div>
              </div>
              <span className="text-red-400 mx-2">
                {error && !form.newKeyword && "โปรดใส่คียเวิร์ด"}
              </span>
              <div className="flex items-center">
                {form.keyword.map((word, index) => (
                  <span
                    onClick={deleteKeyword(index)}
                    className="cursor-pointer duration-300 hover:bg-blue-400 hover:text-white mx-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-600 border border-blue-600 rounded mr-2"
                  >
                    {word}
                    <span className="text-white-500  ml-2">X</span>
                  </span>
                ))}
              </div>
            </div>
          </Dialog.Description>
          <button
            disabled={loadingAdd}
            className={classNames("p-2 text-white w-20 mr-4 rounded", {
              "bg-blue-500 cursor-pointer": !loadingAdd,
              "bg-gray-400 cursor-not-allowed": loadingAdd,
            })}
            onClick={onSubmit}
          >
            {loadingAdd ? "Loading..." : "ยืนยัน"}
          </button>
          <button
            className="p-2 text-blue-500 border border-blue-500 w-20 rounded"
            onClick={() => setShowModal(false)}
          >
            ยกเลิก
          </button>
        </div>
      </div>
    </Dialog>
  );
};

function ChatBotTable({ data, getData }) {
  const { user } = useSelector((state) => state.initializeApp);

  const onDelete = (order) => async (e) => {
    try {
      e.stopPropagation();
      await API.del("MoneyHubAdmin", `/chatbot/${order}`, {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await EmitterStatus("SUCCESS");
      await getData({}, { isLoading: true });
    } catch (error) {
      await EmitterStatus("ERROR", { logMessage: error });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "คำตอบ",
        accessor: "answer",
      },
      {
        Header: "คีย์เวิร์ด",
        accessor: "keyword",
        Cell: ({ row }) => {
          const { keyword } = row.original;
          return keyword.map((word) => (
            <span className="mx-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-600 border border-blue-600 rounded">
              {word}
            </span>
          ));
        },
      },
      {
        Header: "",
        accessor: "delete",
        Cell: ({ row }) => {
          const { order } = row.original;
          return (
            <button
              onClick={onDelete(order)}
              className={classNames(
                "mx-2 px-2 py-1 text-sm rounded text-white shadow-sm duration-300 transition-all focus:outline-none bg-red-500 hover:bg-red-600"
              )}
            >
              DELETE
            </button>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  return (
    <div className="mx-4 mb-2">
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3", {
                      "text-left": i === 0,
                      "text-center": i !== 0,
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ChatBotTable;
